import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './config';

export async function captureResearchLead(email: string): Promise<void> {
    const ref = collection(db, 'researchLeads');
    await addDoc(ref, { email: email.trim().toLowerCase(), createdAt: serverTimestamp() });
}
